"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _table = require("@alicd/next/lib/table");

var _table2 = _interopRequireDefault(_table);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _grid = require("@alicd/next/lib/grid");

var _grid2 = _interopRequireDefault(_grid);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _debounce = require("debounce");

var _debounce2 = _interopRequireDefault(_debounce);

var _localeProvider = require("@alicd/next/lib/locale-provider");

var _localeProvider2 = _interopRequireDefault(_localeProvider);

var _Column = require("./Column");

var _Column2 = _interopRequireDefault(_Column);

var _ColumnGroup = require("./ColumnGroup");

var _ColumnGroup2 = _interopRequireDefault(_ColumnGroup);

var _CNTableScrollOverlay = require("./CNTableScrollOverlay");

var _CNTableScrollOverlay2 = _interopRequireDefault(_CNTableScrollOverlay);

var _CNTableCellUtils = require("./CNTableCellUtils");

var CellUtils = _interopRequireWildcard(_CNTableCellUtils);

var _columnUtils = require("./column-utils");

var ColumnUtils = _interopRequireWildcard(_columnUtils);

var _Monkey = require("./Monkey");

var _locale = require("./locale");

var _locale2 = _interopRequireDefault(_locale);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = _grid2.default.Row,
    Col = _grid2.default.Col;

var CNTable = function (_React$Component) {
    (0, _inherits3.default)(CNTable, _React$Component);

    function CNTable(props) {
        (0, _classCallCheck3.default)(this, CNTable);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CNTable.__proto__ || (0, _getPrototypeOf2.default)(CNTable)).call(this, props));

        _this.state = {
            layoutTableScrollWidth: 0,
            layoutTableClientWidth: 0,
            layoutTableRect: {
                bottom: 0,
                left: 0,
                top: 0
            },
            rowSelection: null
            // stickyHeaderPage: null,
        };

        _this.scrollLeft = 0;
        _this.layoutListenerHooked = false;

        _this.getRowClassNameOverride = _this.getRowClassNameOverride.bind(_this);
        // this.updateLayout = debounce(this.updateLayout.bind(this), 128);
        _this.updateLayoutAutoColumnsDebounced = (0, _debounce2.default)(function () {
            return requestAnimationFrame(_this.updateLayoutAutoColumns.bind(_this));
        }, 1);
        _this.updateLayoutScrollbar = (0, _debounce2.default)(_this.updateLayoutScrollbar.bind(_this), 128);
        _this.updateOverlayScroll = _this.updateOverlayScroll.bind(_this);
        _this.handleScrollOverlay = _this.handleScrollOverlay.bind(_this);
        _this.handleDefaultExpandAllRowOpen = _this.handleDefaultExpandAllRowOpen.bind(_this);
        _this.updateLayoutStickyHeaderPage = _this.updateLayoutStickyHeaderPage.bind(_this);

        if (_this.isDefaultExpandAllEnabledOnProps(props)) {
            _this.state.openRowKeys = [].concat((0, _toConsumableArray3.default)(ColumnUtils.getAllKeySetOfTree(props.dataSource, props.primaryKey)));
        }

        _this.autoMinWidthColumns = {};

        _this.treeExpandableKeySet = new _set2.default();
        _this.updateRowSelection(_this.props.rowSelection, function (obj) {
            return (0, _assign2.default)(_this.state, obj);
        });
        return _this;
    }

    (0, _createClass3.default)(CNTable, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.fixedScrollbar) {
                this.fixedScrollbarInit();
            }
            if (this.props.useAutomaticLayout) {
                this.automaticLayoutInit();
            }
            if (this.stickyHeaderEnabled()) {
                this.stickyHeaderPageInit();
                this.updateLayoutStickyHeaderPage();
            }
            // this.refs.nextTable.getInstance().adjustHeaderSize = adjustHeaderSize
            setTimeout(function () {
                return requestAnimationFrame(function () {
                    if (_this2.refs.nextTable) {
                        _this2.refs.nextTable.getInstance().adjustSize();
                    }
                });
            }, 0);

            this.updateRowSelection(this.props.rowSelection);
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.fixedScrollbar && !this.props.fixedScrollbar) {
                this.fixedScrollbarInit();
            } else if (!nextProps.fixedScrollbar && this.props.fixedScrollbar) {
                this.fixedScrollbarUninit();
            }
            if (nextProps.useAutomaticLayout && !this.props.useAutomaticLayout) {
                this.automaticLayoutInit();
            } else if (!nextProps.useAutomaticLayout && this.props.useAutomaticLayout) {
                this.automaticLayoutUninit();
            }

            if (this.isDefaultExpandAllEnabledOnProps(nextProps)) {
                var curAvailable = this.props.isTree && this.props.defaultExpandAll;
                // const allKeysCur = curAvailable ? ColumnUtils.getAllExpandableKeySetOfTree(
                //     this.props.dataSource, this.props.primaryKey) : new Set()
                var allKeysNext = ColumnUtils.getAllExpandableKeySetOfTree(nextProps.dataSource, nextProps.primaryKey);
                var openedKeysCur = curAvailable ? new _set2.default(this.state.openRowKeys) : new _set2.default();
                var closedKeys = new _set2.default([].concat((0, _toConsumableArray3.default)(this.treeExpandableKeySet)).filter(function (k) {
                    return !openedKeysCur.has(k);
                }));
                var nextKeys = new _set2.default([].concat((0, _toConsumableArray3.default)(allKeysNext)).filter(function (k) {
                    return !closedKeys.has(k);
                }));
                this.setState({ openRowKeys: [].concat((0, _toConsumableArray3.default)(nextKeys)) });
                this.treeExpandableKeySet = allKeysNext;
            }

            // if (nextProps.rowSelection != this.props.rowSelection) {
            this.updateRowSelection(nextProps.rowSelection);
            // }
        }
    }, {
        key: "updateRowSelection",
        value: function updateRowSelection(rowSelection) {
            var setState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.setState;

            if (rowSelection && typeof rowSelection.getProps == "function") {
                var getPropsOrg = rowSelection.getProps;
                var getProps = function getProps(record) {
                    var ret = getPropsOrg(record);
                    if (ret && ret.hidden) {
                        return (0, _extends3.default)({}, ret, {
                            disabled: true,
                            className: (0, _classnames2.default)(ret.className, "cn-table-select-hide")
                        });
                    }
                    return ret;
                };
                rowSelection = (0, _extends3.default)({}, rowSelection, { getProps: getProps });
            }
            setState.call(this, { rowSelection: rowSelection });
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.props.useAutomaticLayout) {
                this.updateLayoutAutoColumnsDebounced();
            }
            if (this.stickyHeaderEnabled()) {
                this.updateLayoutStickyHeaderPage();
            }
            // if (prevState.stickyHeaderPage !== this.state.stickyHeaderPage) {
            //     if (typeof this.state.stickyHeaderPage == "number") {
            //         this.setStickyHeaderPage(this.state.stickyHeaderPage);
            //     } else { this.clearStickyHeaderPage(); }
            // }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            if (this.props.fixedScrollbar) {
                this.fixedScrollbarUninit();
            }
            if (this.props.useAutomaticLayout) {
                this.automaticLayoutUninit();
            }
            if (this.stickyHeaderEnabled()) {
                this.stickyHeaderPageUninit();
            }
        }
    }, {
        key: "handleDefaultExpandAllRowOpen",
        value: function handleDefaultExpandAllRowOpen(openRowKeys, currentRowKey, opened, currentRecord) {
            this.setState({ openRowKeys: openRowKeys });
        }
    }, {
        key: "isDefaultExpandAllEnabledOnProps",
        value: function isDefaultExpandAllEnabledOnProps(props) {
            return props.isTree && props.defaultExpandAll && !Array.isArray(props.openRowKeys);
        }
    }, {
        key: "isRowHighlighted",
        value: function isRowHighlighted(record, index) {
            if (typeof this.props.getRowHighlighted != "function") {
                return false;
            }
            return !!this.props.getRowHighlighted(record, index);
        }
    }, {
        key: "getRowClassNameOverride",
        value: function getRowClassNameOverride(record, index) {
            var ret = [];
            if (this.isRowHighlighted(record, index)) {
                ret.push("highlighted");
            }
            if (typeof this.props.getRowClassName == "function") {
                return (0, _classnames2.default)(ret, this.props.getRowClassName(record, index));
            } else {
                return (0, _classnames2.default)(ret);
            }
        }
    }, {
        key: "getCellPropsOverride",
        value: function getCellPropsOverride(rowIndex, colIndex, record) {}
    }, {
        key: "updateLayoutAutoColumns",
        value: function updateLayoutAutoColumns() {
            var _this3 = this;

            var nextTable = this.refs.nextTable && this.refs.nextTable.getInstance();
            if (!nextTable) {
                return;
            }

            var tableBodyDOM = _reactDom2.default.findDOMNode(nextTable.refs.body);
            var tableDOM = ColumnUtils.findDirectChildByTagName(tableBodyDOM, "table");
            tableDOM.style.minWidth = 0;
            var n = nextTable.state.flatChildren.length;

            var columnMinWidths = nextTable.state.flatChildren.map(function (child) {
                if (child.cnTableProps && (child.cnTableProps.width || child.cnTableProps.minWidth || child.cnTableProps.autoMinWidth)) {
                    return CellUtils.getColumnMinWidth(_this3, child.cnTableProps, child.cnTableColIndex, child.cnTableXIndex, child.cnTableYIndex);
                } else {
                    return 0;
                }
            });

            var updateCellDOM = function updateCellDOM(rowIdx, i, lock) {
                // TODO: not effective if we have merged cells
                // TODO: investegate the effect that min-width induces on layout
                //  (when we have enough space, min-width would affect the width proportion)
                var cellDOM = _reactDom2.default.findDOMNode(nextTable.refs[nextTable.getCellRef(rowIdx, i, lock)]);
                if (cellDOM) {
                    var cellInnerDOM = cellDOM.getElementsByClassName("cn-table-cell-auto-layout")[0];
                    if (cellInnerDOM) {
                        cellInnerDOM.style.minWidth = columnMinWidths[i] + "px";
                    }
                }
            };
            nextTable.state.flatChildren.forEach(function (column) {
                if (typeof column.cnTableColIndex == "number") {
                    updateCellDOM(0, column.cnTableColIndex);
                    updateCellDOM(0, column.cnTableColIndex, "left");
                    updateCellDOM(0, column.cnTableColIndex, "right");
                }
            });

            // ColumnUtils.columnCount(this.props.children) + (this.props.rowSelection ? 1 : 0)
            // TODO: optimize this DOM append
            var columnWidths = ColumnUtils.getColumnWidths(tableDOM, n).map(function (w, i) {
                return Math.max(w, columnMinWidths[i]);
            });

            // NOTE: we assume a "standard" DOM tree layout
            var findColGroupDOM = function findColGroupDOM(p) {
                return ColumnUtils.findDirectChildByTagName(ColumnUtils.findDirectChildByTagName(p, "table"), "colgroup");
            };
            var ref = function ref(lock, type) {
                return nextTable.refs[nextTable.getTableRef(lock, type)];
            };
            var getColGroupsDOM = function getColGroupsDOM(dir) {
                var ret = {
                    bodyColGroupDOM: findColGroupDOM(_reactDom2.default.findDOMNode(ref(dir, "body")))
                };
                var innerHeaderRef = ref(dir, "innerHeader");
                if (innerHeaderRef) {
                    ret.headerColGroupDOM = findColGroupDOM(_reactDom2.default.findDOMNode(innerHeaderRef));
                }
                return ret;
            };

            var headerColGroupRef = ref(false, "innerHeader");
            if (headerColGroupRef) {
                var headerColGroupDOM = findColGroupDOM(headerColGroupRef);
                // const totalWidth = ColumnUtils.sumArray(columnWidths) + (columnWidths.length - 2)
                // headerTableDOM.style.width = `${totalWidth}px`
                columnWidths.forEach(function (w, i) {
                    return headerColGroupDOM.childNodes[i].style.width = w + "px";
                });
            }

            if (nextTable.state.dataSource && nextTable.state.dataSource.length) {

                var setColWidth = function setColWidth(g, w, i) {
                    var value = w + "px";
                    g.headerColGroupDOM && (g.headerColGroupDOM.childNodes[i].style.width = value);
                    g.bodyColGroupDOM && (g.bodyColGroupDOM.childNodes[i].style.width = value);
                };

                if (nextTable.state.lockLeftChildren.length) {
                    var g = getColGroupsDOM("left");
                    columnWidths.slice(0, nextTable.state.lockLeftChildren.length).forEach(setColWidth.bind(null, g));
                }

                if (nextTable.state.lockRightChildren.length) {
                    var _g = getColGroupsDOM("right");
                    var k = n - nextTable.state.lockRightChildren.length;
                    columnWidths.slice(k, n).forEach(setColWidth.bind(null, _g));
                }
            }

            nextTable.adjustIfTableNotNeedLock();
            // TODO: further investigate the headerRowHeight issue
            nextTable.adjustHeaderSize();

            this.syncBodyWidthWithHeader();
        }
    }, {
        key: "syncBodyWidthWithHeader",
        value: function syncBodyWidthWithHeader() {
            if (!this.props.hasHeader) {
                return;
            }
            var nextTable = this.refs.nextTable && this.refs.nextTable.getInstance();
            if (!nextTable) {
                return;
            }

            var tableBodyDOM = _reactDom2.default.findDOMNode(nextTable.refs.body);
            var tableDOM = ColumnUtils.findDirectChildByTagName(tableBodyDOM, "table");

            var tableHeaderDOM = _reactDom2.default.findDOMNode(nextTable.refs.header);
            var headerDOM = ColumnUtils.findDirectChildByTagName(ColumnUtils.findDirectChildByClassName(tableHeaderDOM, "next-table-header-inner"), "table");

            if (tableDOM && headerDOM) {
                tableDOM.style.minWidth = headerDOM.getBoundingClientRect().width + "px";
            }
        }

        // BEGIN === STICKY HEADER ===

    }, {
        key: "stickyHeaderEnabled",
        value: function stickyHeaderEnabled() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return typeof this.props.stickyHeaderViewport == "number" || typeof this.props.stickyHeaderViewport == "function";
        }
    }, {
        key: "stickyHeaderPageInit",
        value: function stickyHeaderPageInit() {
            window.addEventListener("resize", this.updateLayoutStickyHeaderPage);
            window.addEventListener("scroll", this.updateLayoutStickyHeaderPage);
        }
    }, {
        key: "stickyHeaderPageUninit",
        value: function stickyHeaderPageUninit() {
            window.removeEventListener("resize", this.updateLayoutStickyHeaderPage);
            window.removeEventListener("scroll", this.updateLayoutStickyHeaderPage);
        }
    }, {
        key: "setStickyHeaderPage",
        value: function setStickyHeaderPage(top) {

            function setHeader(tableHeaderDOM, tableBodyWrap) {
                // TODO: fix shadow
                tableHeaderDOM.style.position = "fixed";
                tableHeaderDOM.style.width = tableBodyWrap.getBoundingClientRect().width + "px";
                tableHeaderDOM.style.left = tableBodyWrap.getBoundingClientRect().left + "px";
                tableHeaderDOM.style.top = top + "px";
                tableHeaderDOM.style.zIndex = 1;
                tableHeaderDOM.classList.add("cn-sticky-active");
            }

            var nextTable = this.refs.nextTable && this.refs.nextTable.getInstance();
            if (!nextTable) {
                return;
            }
            var tableHeaderDOM = _reactDom2.default.findDOMNode(nextTable.refs.header);
            var tableElement = _reactDom2.default.findDOMNode(this.refs.nextTable);
            var tableBodyWrap = tableElement.getElementsByClassName("next-table-body")[0];
            if (!tableHeaderDOM) {
                return;
            }

            var tableHeaderInnerDOM = tableHeaderDOM.getElementsByClassName("next-table-header-inner")[0];
            var scroll = tableHeaderInnerDOM.scrollLeft;

            var placeholderDOM = _reactDom2.default.findDOMNode(this.refs.fixedPlaceholder);
            placeholderDOM.style.height = tableHeaderDOM.getBoundingClientRect().height + "px";

            setHeader(tableHeaderDOM, tableBodyWrap);

            if (nextTable.refs.lock_leftheader) {
                var _tableHeaderDOM = _reactDom2.default.findDOMNode(nextTable.refs.lock_leftheader);
                var _tableBodyWrap = _reactDom2.default.findDOMNode(nextTable.refs.lock_leftbody);
                setHeader(_tableHeaderDOM, _tableBodyWrap);
            }

            if (nextTable.refs.lock_rightheader) {
                var _tableHeaderDOM2 = _reactDom2.default.findDOMNode(nextTable.refs.lock_rightheader);
                var _tableBodyWrap2 = _reactDom2.default.findDOMNode(nextTable.refs.lock_rightbody);
                setHeader(_tableHeaderDOM2, _tableBodyWrap2);
            }

            tableHeaderInnerDOM.scrollLeft = scroll;
        }
    }, {
        key: "clearStickyHeaderPage",
        value: function clearStickyHeaderPage() {
            var nextTable = this.refs.nextTable && this.refs.nextTable.getInstance();
            if (!nextTable) {
                return;
            }
            var tableHeaderDOM = _reactDom2.default.findDOMNode(nextTable.refs.header);
            if (!tableHeaderDOM) {
                return;
            }

            function clearHeader(tableHeaderDOM) {
                tableHeaderDOM.style.position = "relative";
                tableHeaderDOM.style.width = "auto";
                tableHeaderDOM.style.top = "auto";
                tableHeaderDOM.style.left = "auto";
                tableHeaderDOM.classList.remove("cn-sticky-active");
            }
            clearHeader(tableHeaderDOM);
            if (nextTable.refs.lock_leftheader) {
                var _tableHeaderDOM3 = _reactDom2.default.findDOMNode(nextTable.refs.lock_leftheader);
                clearHeader(_tableHeaderDOM3);
            }

            if (nextTable.refs.lock_rightheader) {
                var _tableHeaderDOM4 = _reactDom2.default.findDOMNode(nextTable.refs.lock_rightheader);
                clearHeader(_tableHeaderDOM4);
            }

            var placeholderDOM = _reactDom2.default.findDOMNode(this.refs.fixedPlaceholder);
            placeholderDOM.style.height = 0;
        }
    }, {
        key: "updateLayoutStickyHeaderPage",
        value: function updateLayoutStickyHeaderPage() {
            if (typeof this.props.stickyHeaderViewport == "number") {
                // this.setState({ stickyHeaderPage: this.props.stickyHeaderPage });
                this.setStickyHeaderPage(this.props.stickyHeaderViewport);
                return;
            } else if (typeof this.props.stickyHeaderViewport == "function") {
                var placeholderDOM = _reactDom2.default.findDOMNode(this.refs.fixedPlaceholder);
                var nextTable = _reactDom2.default.findDOMNode(this.refs.nextTable && this.refs.nextTable.getInstance());
                var ret = this.props.stickyHeaderViewport(placeholderDOM.getBoundingClientRect().top, nextTable.getBoundingClientRect().bottom);
                if (typeof ret == "number") {
                    // this.setState({ stickyHeaderPage: ret });
                    this.setStickyHeaderPage(ret);
                    return;
                }
            }
            // this.setState({ stickyHeaderPage: null });
            this.clearStickyHeaderPage();
        }

        // END === STICKY HEADER ===

    }, {
        key: "automaticLayoutInit",
        value: function automaticLayoutInit() {
            this.updateLayoutAutoColumnsDebounced();
            window.addEventListener("resize", this.updateLayoutAutoColumnsDebounced);
        }
    }, {
        key: "automaticLayoutUninit",
        value: function automaticLayoutUninit() {
            this.updateLayoutAutoColumnsDebounced();
            window.removeEventListener("resize", this.updateLayoutAutoColumnsDebounced);
        }
    }, {
        key: "fixedScrollbarInit",
        value: function fixedScrollbarInit() {
            this.updateLayoutScrollbar();

            window.addEventListener("scroll", this.updateLayoutScrollbar);
            window.addEventListener("resize", this.updateLayoutScrollbar);

            var scrollHookOriginal = this.refs.nextTable.getInstance().onBodyScroll;
            this.scrollHookOriginal = scrollHookOriginal;
            var updateOverlayScroll = this.updateOverlayScroll;

            function scrollHook() {
                // console.log("update scroll hook")
                scrollHookOriginal.call(this);
                updateOverlayScroll();
            }
            this.refs.nextTable.getInstance().onBodyScroll = scrollHook;
        }
    }, {
        key: "fixedScrollbarUninit",
        value: function fixedScrollbarUninit() {
            window.removeEventListener("scroll", this.updateLayoutScrollbar);
            window.removeEventListener("resize", this.updateLayoutScrollbar);
            this.refs.nextTable.getInstance().onBodyScroll = this.scrollHookOriginal;
        }
    }, {
        key: "updateLayoutScrollbar",
        value: function updateLayoutScrollbar() {
            // console.log("update scroll")
            var tableElement = _reactDom2.default.findDOMNode(this.refs.nextTable);
            var tableBodyWrap = tableElement.getElementsByClassName("next-table-body")[0];
            var tableRect = tableElement.getBoundingClientRect();
            var layoutObj = {
                layoutTableScrollWidth: tableBodyWrap.scrollWidth,
                layoutTableClientWidth: tableBodyWrap.clientWidth,
                layoutTableRect: {
                    bottom: tableRect.bottom,
                    left: tableRect.left,
                    top: tableRect.top
                }
            };

            if (this.tableHaveScrollbarAndInViewport(layoutObj) != this.tableHaveScrollbarAndInViewport(this.state)) {
                this.setState(layoutObj);
            }
        }
    }, {
        key: "updateOverlayScroll",
        value: function updateOverlayScroll() {
            var tableElement = _reactDom2.default.findDOMNode(this.refs.nextTable);
            var tableBodyWrap = tableElement.getElementsByClassName("next-table-body")[0];
            if (this.state.scrollLeft != tableBodyWrap.scrollLeft) {
                this.ignoreScrollOverlayEvent = true;
                this.scrollLeft = tableBodyWrap.scrollLeft;
                this.refs.scrollOverlay && this.refs.scrollOverlay.updateScroll(this.scrollLeft);
            }
        }
    }, {
        key: "handleScrollOverlay",
        value: function handleScrollOverlay(currScroll) {

            if (this.ignoreScrollOverlayEvent) {
                this.ignoreScrollOverlayEvent = false;
                return;
            }

            var tableElement = _reactDom2.default.findDOMNode(this.refs.nextTable);
            var tableBodyWrap = tableElement.getElementsByClassName("next-table-body")[0];
            if (tableBodyWrap.scrollLeft != currScroll) {
                tableBodyWrap.scrollLeft = currScroll;
            }
        }
    }, {
        key: "tableHaveScrollbarAndInViewport",
        value: function tableHaveScrollbarAndInViewport() {
            var layoutObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;
            var layoutTableRect = layoutObj.layoutTableRect,
                layoutTableClientWidth = layoutObj.layoutTableClientWidth,
                layoutTableScrollWidth = layoutObj.layoutTableScrollWidth;

            return layoutTableClientWidth < layoutTableScrollWidth && layoutTableRect.bottom >= window.innerHeight && layoutTableRect.top <= window.innerHeight;
        }
    }, {
        key: "renderScrollOverlay",
        value: function renderScrollOverlay() {

            if (!this.props.fixedScrollbar) {
                return;
            }

            var _state = this.state,
                layoutTableRect = _state.layoutTableRect,
                layoutTableClientWidth = _state.layoutTableClientWidth,
                layoutTableScrollWidth = _state.layoutTableScrollWidth;

            // do not show scrollbar overlay
            //  if: the table does not need a horizontal scrollbar at all

            if (
            // or the native horizontal scrollbar is inside the viewport
            // or the table is above (outside) the top of viewport
            !this.tableHaveScrollbarAndInViewport(this.state)
            // or the table is under (outside) the bottom of viewport
            ) {
                    return null;
                }

            var styleOuter = {
                left: layoutTableRect.left + "px"
            };

            return _react2.default.createElement(_CNTableScrollOverlay2.default, {
                ref: "scrollOverlay",
                style: styleOuter,
                onScroll: this.handleScrollOverlay,
                clientWidth: layoutTableClientWidth,
                scrollWidth: layoutTableScrollWidth,
                value: this.scrollLeft
            });
        }
    }, {
        key: "renderCellCallback",
        value: function renderCellCallback(ctx, value, record, index, self) {
            var sequence = CellUtils.sequence,
                unwrapParamsToElement = CellUtils.unwrapParamsToElement,
                renderCellWrapCopy = CellUtils.renderCellWrapCopy,
                renderCellWrapTooltip = CellUtils.renderCellWrapTooltip,
                renderCellClickTrigger = CellUtils.renderCellClickTrigger,
                renderCellWrapStyle = CellUtils.renderCellWrapStyle,
                renderCellWrapTextWrapWidth = CellUtils.renderCellWrapTextWrapWidth,
                renderCellInnermost = CellUtils.renderCellInnermost,
                renderCellWrapAutoLayout = CellUtils.renderCellWrapAutoLayout,
                renderCellIdentity = CellUtils.renderCellIdentity,
                renderCellWrapGreedy = CellUtils.renderCellWrapGreedy;


            var colId = {
                idx: this.cnTableColIndex,
                x: this.cnTableXIndex,
                y: this.cnTableYIndex
            };

            return sequence(renderCellInnermost, renderCellWrapGreedy, renderCellWrapTextWrapWidth, renderCellWrapTooltip, renderCellWrapCopy, renderCellWrapStyle, renderCellClickTrigger, self.props.useAutomaticLayout ? renderCellWrapAutoLayout : renderCellIdentity, unwrapParamsToElement).call(this, value, record, index, ctx.self, colId);
        }
    }, {
        key: "renderColumn",
        value: function renderColumn(self, i, l, levelCount, child) {
            levelCount[l] = levelCount[l] || 0;

            var sequence = CellUtils.sequence,
                unwrapParamsToElement = CellUtils.unwrapParamsToElement,
                renderHeaderInnermost = CellUtils.renderHeaderInnermost,
                renderCellWrapAutoLayout = CellUtils.renderCellWrapAutoLayout,
                renderCellIdentity = CellUtils.renderCellIdentity,
                renderCellWrapGreedy = CellUtils.renderCellWrapGreedy,
                renderTitleWrapAutoLayout = CellUtils.renderTitleWrapAutoLayout;


            if (child.type == _Column2.default) {
                child = self.preprocessColumn(child);

                var _child$props = child.props,
                    wrap = _child$props.wrap,
                    titleTooltip = _child$props.titleTooltip,
                    contentTooltip = _child$props.contentTooltip,
                    copy = _child$props.copy,
                    onBeforeCopy = _child$props.onBeforeCopy,
                    onCopy = _child$props.onCopy,
                    clickToSelectRow = _child$props.clickToSelectRow,
                    onClick = _child$props.onClick,
                    autoMinWidth = _child$props.autoMinWidth,
                    className = _child$props.className,
                    title = _child$props.title,
                    dataIndex = _child$props.dataIndex,
                    cell = _child$props.cell,
                    children = _child$props.children,
                    style = _child$props.style,
                    otherProps = (0, _objectWithoutProperties3.default)(_child$props, ["wrap", "titleTooltip", "contentTooltip", "copy", "onBeforeCopy", "onCopy", "clickToSelectRow", "onClick", "autoMinWidth", "className", "title", "dataIndex", "cell", "children", "style"]);

                var cellOverrideNeeded = !!(contentTooltip || copy || clickToSelectRow || onClick || this.props.useAutomaticLayout);

                var titleFinal = sequence(renderHeaderInnermost, child.props.autoMinWidth ? CellUtils.renderTitleWithAutoMinWidth(i) : renderCellIdentity, renderCellWrapGreedy, self.props.useAutomaticLayout ? renderTitleWrapAutoLayout : renderCellIdentity, unwrapParamsToElement).call(child, titleTooltip ? CellUtils.renderTitleWithTooltip(title, titleTooltip) : title, self, i);

                var widthStyle = {};
                if (child.props.width) {
                    widthStyle.width = widthStyle.minWidth = widthStyle.maxWidth = child.props.width;
                }
                if (child.props.maxWidth) {
                    widthStyle.maxWidth = child.props.maxWidth;
                }

                // suppress the warning of width and lock column ...
                if (!("width" in child.props) && otherProps.lock) {
                    otherProps.width = undefined;
                }

                // TODO: does ColumnGroup use style?
                (0, _assign2.default)(widthStyle, child.props.style);
                if (cellOverrideNeeded) {
                    var cellOverrideCallbackWrap = function cellOverrideCallbackWrap() {
                        var _self$renderCellCallb;

                        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                            args[_key] = arguments[_key];
                        }

                        return (_self$renderCellCallb = self.renderCellCallback).call.apply(_self$renderCellCallb, [this, { self: self }].concat(args));
                    };

                    return {
                        element: _react2.default.createElement(
                            _table2.default.Column,
                            (0, _extends3.default)({}, otherProps, {
                                title: titleFinal,
                                dataIndex: dataIndex,
                                cell: cellOverrideCallbackWrap,
                                cnTableProps: child.props,
                                cnTableColIndex: i,
                                cnTableXIndex: levelCount[l],
                                cnTableYIndex: l,
                                className: className,
                                style: widthStyle
                            }),
                            children
                        ),
                        colCounter: ++i
                    };
                } else {
                    var propField = cell ? { dataIndex: dataIndex, cell: cell } : { dataIndex: dataIndex };
                    var classNameWithWrap = wrap ? className : (0, _classnames2.default)(className, "cn-table-cell-nowrap");
                    return {
                        element: _react2.default.createElement(
                            _table2.default.Column,
                            (0, _extends3.default)({}, otherProps, propField, {
                                className: classNameWithWrap,
                                title: titleFinal,
                                style: widthStyle,
                                cnTableColIndex: i,
                                cnTableXIndex: levelCount[l],
                                cnTableYIndex: l
                            }),
                            children
                        ),
                        colCounter: ++i
                    };
                }
                levelCount[l] += 1;
            } else if (child.type == _ColumnGroup2.default) {
                var _child$props2 = child.props,
                    _title = _child$props2.title,
                    _children = _child$props2.children,
                    _otherProps = (0, _objectWithoutProperties3.default)(_child$props2, ["title", "children"]);

                var cols = _react2.default.Children.map(_children, function (child) {
                    var _self$renderColumn = self.renderColumn(self, i, l + 1, levelCount, child),
                        element = _self$renderColumn.element,
                        colCounter = _self$renderColumn.colCounter;

                    i = colCounter;
                    return element;
                });
                levelCount[l] += 1;

                var titleGroup = sequence(renderHeaderInnermost, self.props.useAutomaticLayout ? renderCellWrapAutoLayout : renderCellIdentity, unwrapParamsToElement).call(child, _title, self);

                return {
                    element: _react2.default.createElement(
                        _table2.default.ColumnGroup,
                        (0, _extends3.default)({}, _otherProps, {
                            title: titleGroup
                        }),
                        cols
                    ),
                    colCounter: i
                };
            } else {
                console.error("The children of <CNTable /> must be <CNTable.Column /> or <CNTable.ColumnGroup>");
            }
        }
    }, {
        key: "preprocessColumn",
        value: function preprocessColumn(child) {
            var _this4 = this;

            if (!child.props.clickToSelectRow) {
                return child;
            } else {
                return _react2.default.cloneElement(child, {
                    onClick: this.props.rowSelection ? function (value, index, record, e) {
                        var checked = _this4.refs.nextTable.getInstance().state.selectedRowKeys
                        /* .cnTableGetSelectedRowKeys()*/
                        .indexOf(record[_this4.props.primaryKey]) <= -1;
                        _this4.refs.nextTable.getInstance().selectOneRow(index, record, checked, e);
                        child.props.onClick && child.props.onClick(index, record, e);
                    } : child.props.onClick
                });
            }
        }
    }, {
        key: "renderColumns",
        value: function renderColumns(children) {
            var _this5 = this;

            var i = this.props.rowSelection ? 1 : 0;
            i += this.props.hasExpandedRowCtrl && this.props.expandedRowRender ? 1 : 0;
            var levelCount = { 0: i };
            return _react2.default.Children.map(children, function (child) {
                var _renderColumn = _this5.renderColumn(_this5, i, 0, levelCount, child),
                    element = _renderColumn.element,
                    colCounter = _renderColumn.colCounter;

                i = colCounter;
                levelCount[0] += 1;
                return element;
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                getRowHighlighted = _props.getRowHighlighted,
                className = _props.className,
                children = _props.children,
                defaultExpandAll = _props.defaultExpandAll,
                rowSelection = _props.rowSelection,
                stickyHeaderViewport = _props.stickyHeaderViewport,
                otherProps = (0, _objectWithoutProperties3.default)(_props, ["getRowHighlighted", "className", "children", "defaultExpandAll", "rowSelection", "stickyHeaderViewport"]);

            if (typeof getRowHighlighted == "function") {
                otherProps.getRowClassName = this.getRowClassNameOverride;
            }
            var classes = [];
            if (this.props.useAutomaticLayout) {
                classes.push("cn-table-auto-layout");
            }
            if (this.isDefaultExpandAllEnabledOnProps(this.props)) {
                otherProps.openRowKeys = this.state.openRowKeys;
                otherProps.onRowOpen = this.handleDefaultExpandAllRowOpen;
            }

            if (this.state.rowSelection) {
                otherProps.rowSelection = this.state.rowSelection;
            }

            return _react2.default.createElement(
                "div",
                { className: "cn-table-wrap" },
                this.stickyHeaderEnabled() ? _react2.default.createElement("div", { ref: "fixedPlaceholder", className: "cn-sticky-placeholder" }) : null,
                _react2.default.createElement(
                    _Monkey.CNTableBase,
                    (0, _extends3.default)({
                        ref: "nextTable"
                    }, otherProps, {
                        className: (0, _classnames2.default)("cn-table", classes, this.props.className)
                    }),
                    this.renderColumns(children)
                ),
                this.renderScrollOverlay()
            );
        }
    }]);
    return CNTable;
}(_react2.default.Component);

CNTable.propTypes = {
    fixedScrollbar: _propTypes2.default.bool,
    getRowHighlighted: _propTypes2.default.func,
    getRowClassName: _propTypes2.default.func,
    useAutomaticLayout: _propTypes2.default.bool,
    locale: _propTypes2.default.object,
    defaultExpandAll: _propTypes2.default.bool,
    hasExpandedRowCtrl: _propTypes2.default.bool,
    lockExpandedRowCtrl: _propTypes2.default.bool,
    hasHeader: _propTypes2.default.bool,
    stickyHeaderViewport: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.number]),
    treeArrowIndent: _propTypes2.default.number
};
CNTable.defaultProps = {
    fixedScrollbar: false,
    useAutomaticLayout: false,
    defaultExpandAll: false,
    hasExpandedRowCtrl: true,
    lockExpandedRowCtrl: false,
    hasHeader: true,
    stickyHeaderViewport: null,
    treeArrowIndent: 0
};


var CNTableWithLocale = (0, _localeProvider2.default)(CNTable);
CNTableWithLocale.LOCALE = _locale2.default;

CNTableWithLocale.Column = _Column2.default;
CNTableWithLocale.ColumnGroup = _ColumnGroup2.default;

exports.default = CNTableWithLocale;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table@0.0.78@@alicd/crui-table/lib/CNTable.js
// module id = 680
// module chunks = 0